export type ParsedSensorPacket = {
  gsrRaw: number | null;
  gsrSmooth: number | null;
  gsrDisplay: number | null;
};

function toFiniteNumber(value: unknown): number | null {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return null;

    const parsed = Number(trimmed);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
}

function parseCompactPacket(line: string): ParsedSensorPacket | null {
  const parts = line.split(",");
  if (parts.length !== 2) {
    return null;
  }

  const gsrRaw = toFiniteNumber(parts[0]);
  const gsrDisplay = toFiniteNumber(parts[1]);

  if (gsrRaw == null && gsrDisplay == null) {
    return null;
  }

  return {
    gsrRaw: gsrRaw ?? gsrDisplay,
    gsrSmooth: gsrDisplay ?? gsrRaw,
    gsrDisplay: gsrDisplay ?? gsrRaw,
  };
}

export function parseSensorPacket(line: string): ParsedSensorPacket | null {
  const trimmed = line.trim();
  if (!trimmed) return null;

  return parseCompactPacket(trimmed);
}
